import React from 'react';
import { LoadingIndicator } from '@atlassian/temp-loading-indicator';
import { AppLoader } from '@css-xp/ppc-page-loaders';
import { ErrorComponents, useApplicationContext } from '@css-xp/base';
import { useFeatureGates } from './hooks';

export interface FeatureGatesInitializeProps {
  children: JSX.Element | JSX.Element[];
}

export const FeatureGatesInitialize = ({ children }: FeatureGatesInitializeProps) => {
  const state = useFeatureGates();
  const { showNewAppLoader } = useApplicationContext();

  if (state.loading) {
    return showNewAppLoader ? <AppLoader /> : <LoadingIndicator />;
  } else if (state.error) {
    return <ErrorComponents.GenericErrorPage error={state.error} />;
  }
  return <>{children}</>;
};
